"use client";
import React from "react";
import Link from "next/link";

export interface ServiceNavItem {
  href: string;
  icon: React.ReactNode;
  label: string;
}

const ALL_SERVICES: ServiceNavItem[] = [
  {
    href: "/managed-it-services",
    label: "Managed IT",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2.5"/>
        <path d="M8 21h8M12 17v4"/>
        <path d="M6 10h3l1.5-3 2 6 1.5-3H18" strokeWidth="1.8"/>
        <circle cx="18" cy="6" r="1.2" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    href: "/it-infrastructure",
    label: "Infrastructure",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="2" width="18" height="6" rx="2"/>
        <rect x="3" y="10" width="18" height="6" rx="2"/>
        <circle cx="6.5" cy="5" r="1" fill="currentColor" stroke="none"/>
        <circle cx="6.5" cy="13" r="1" fill="currentColor" stroke="none"/>
        <line x1="10" y1="5" x2="17" y2="5"/>
        <line x1="10" y1="13" x2="17" y2="13"/>
        <path d="M8 18v3M12 18v3M16 18v3"/>
        <line x1="6" y1="21" x2="18" y2="21"/>
      </svg>
    ),
  },
  {
    href: "/network-solutions",
    label: "Network Solutions",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="3" r="1.5"/>
        <circle cx="20" cy="17" r="1.5"/>
        <circle cx="4" cy="17" r="1.5"/>
        <line x1="12" y1="4.5" x2="12" y2="9"/>
        <line x1="14.6" y1="14" x2="18.8" y2="16"/>
        <line x1="9.4" y1="14" x2="5.2" y2="16"/>
      </svg>
    ),
  },
  {
    href: "/cyber-security",
    label: "Cybersecurity",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L4 5.5v5.5c0 5.25 3.4 10.15 8 11.5 4.6-1.35 8-6.25 8-11.5V5.5L12 2z"/>
        <rect x="9.5" y="11" width="5" height="4" rx="1"/>
        <path d="M10.5 11V9.5a1.5 1.5 0 0 1 3 0V11"/>
        <circle cx="12" cy="13.2" r="0.6" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    href: "/cloud-solutions",
    label: "Cloud Solutions",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.5 19h11a4.5 4.5 0 0 0 .5-8.97A7 7 0 0 0 4.06 13.5 3.5 3.5 0 0 0 6.5 19z"/>
        <path d="M9.5 13l2-2 2 2" strokeWidth="1.8"/>
        <path d="M13.5 16l-2 2-2-2" strokeWidth="1.8"/>
        <line x1="11.5" y1="11" x2="11.5" y2="16"/>
      </svg>
    ),
  },
  {
    href: "/business-communications",
    label: "Business Comms",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        <path d="M14.5 2a8.38 8.38 0 0 1 5.5 5.5" strokeWidth="1.6"/>
        <path d="M14.5 5.5A4.5 4.5 0 0 1 18 8.5" strokeWidth="1.6"/>
      </svg>
    ),
  },
  {
    href: "/ai-automation",
    label: "AI & Automation",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a5 5 0 0 0-4.8 3.6A4 4 0 0 0 4 9.5a4 4 0 0 0 1.5 3.1A4.5 4.5 0 0 0 9 17h2"/>
        <path d="M12 2a5 5 0 0 1 4.8 3.6A4 4 0 0 1 20 9.5a4 4 0 0 1-1.5 3.1A4.5 4.5 0 0 1 15 17h-2"/>
        <line x1="12" y1="2" x2="12" y2="22"/>
        <path d="M9 8h6M8 12h8"/>
        <circle cx="9" cy="8" r="0.8" fill="currentColor" stroke="none"/>
        <circle cx="15" cy="8" r="0.8" fill="currentColor" stroke="none"/>
        <circle cx="8" cy="12" r="0.8" fill="currentColor" stroke="none"/>
        <circle cx="16" cy="12" r="0.8" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    href: "/ict-procurement",
    label: "ICT Procurement",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
        <path d="M9.5 15l2 2 3.5-3.5" strokeWidth="1.8"/>
      </svg>
    ),
  },
];

interface ServiceQuickNavProps {
  currentPath: string;
}

export default function ServiceQuickNav({ currentPath }: ServiceQuickNavProps) {
  const others = ALL_SERVICES.filter((s) => s.href !== currentPath);

  return (
    <section
      className="py-10 sm:py-14 border-t"
      style={{ borderColor: "rgba(255,255,255,0.06)", background: "#070B14" }}
    >
      <div className="max-w-container mx-auto px-4 sm:px-6">
        <h2
          className="font-heading font-600 text-[18px] sm:text-[20px] mb-4 sm:mb-6"
          style={{ color: "#F8FAFC" }}
        >
          Explore Our Other Services
        </h2>
        {/* Mobile: horizontal scroll strip */}
        <div
          className="flex gap-3 overflow-x-auto pb-2 md:flex-wrap md:overflow-visible"
          style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" } as React.CSSProperties}
        >
          {others.map((svc) => (
            <Link
              key={svc.href}
              href={svc.href}
              className="flex items-center gap-3 px-4 py-3 rounded-2xl flex-shrink-0 transition-all duration-200 hover:scale-[1.03] group"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.09)",
                minWidth: "160px",
              }}
            >
              <span className="flex-shrink-0" style={{ color: "#60A5FA" }}>{svc.icon}</span>
              <span
                className="text-[13px] font-body font-medium flex-1"
                style={{ color: "#CBD5E1" }}
              >
                {svc.label}
              </span>
              <span
                className="text-[14px] transition-transform duration-200 group-hover:translate-x-0.5 flex-shrink-0"
                style={{ color: "#475569" }}
              >
                →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
